import { COLOR_PALETTE } from 'constants/ui';

export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: '24px',
  gap: '24px',
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const callerInfoStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
};

export const destinationNumberStyles = {
  fontSize: '24px',
  fontWeight: 600,
  color: ({ palette }) => palette.text.strong,
};

export const statusTextStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const hangupButtonStyles = {
  width: 64,
  height: 64,
  borderRadius: '50%',
  backgroundColor: COLOR_PALETTE.RED[6],
  color: '#fff',
  '&:hover': {
    backgroundColor: COLOR_PALETTE.RED[7],
  },
};
